import React from 'react'
import { useSelector } from 'react-redux'

// UI
import { Box, Flex, Heading } from '@chakra-ui/react'

import { Card } from '@/components/Elements'
import { Textarea } from '@/components/Form'

import ApprovalWorkflow from './ApprovalWorkflow'
import OfferOverviewGeneralInfo from './OfferOverviewGeneralInfo'
import OfferSourcingSummaryTable from './OfferSourcingSummaryTable'
import PricingSummaryTable from './PricingSummaryTable'

//Hooks

//Constant
import { offerQuotationGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerQuotationEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import OfferOverviewCommercialInfo from './OfferOverviewCommercialInfo'
import OfferOverviewOfferInfo from './OfferOverviewOfferInfo'
import { offerSourcingGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerSourcingEditRight'

const OfferOverviewForm = () => {
  // Redux State
  const offerPermissions = useSelector(selectOfferPermissions)

  //Transformed State
  const isDisabled = !offerPermissions[offerQuotationGroupPolicyType.QUOTATION_OFFER_OVERVIEW]?.edit

  return (
    <div>
      <Flex gap={2} direction={'column'} h="90%">
        <Box mt="20px" px="3">
          <Heading size="md" mb="2">
            Executive Summary
          </Heading>
          <Textarea
            name="approvalRequestExecutiveSummary"
            placeholder=""
            disabled={isDisabled}
            rows="5"
            isRequired={false}
          />
        </Box>

        <OfferOverviewGeneralInfo />
        <OfferOverviewOfferInfo isDisabled={isDisabled} />
        <OfferOverviewCommercialInfo isDisabled={isDisabled} />
      </Flex>

      <Card title={'Pricing Summary'} hasBorder={false}>
        <Box overflow={'scroll'}>
          <PricingSummaryTable />
        </Box>
      </Card>

      <Card
        title={'Sourcing Summary'}
        hasBorder={false}
        canCollapse={true}
        defaultIsOpen={true}
      >
        <Box
          overflow={'auto'}
          maxH="250px"
          maxW="100%"
        >
          <OfferSourcingSummaryTable />
        </Box>
      </Card>

      <ApprovalWorkflow />
    </div>
  )
}

export default OfferOverviewForm
